import type { UsageArea } from "./types";

export const isWorkflowsUsageArea = (usageArea: UsageArea) =>
  usageArea === "workflows";
